module.exports = __webpack_public_path__ + "img/comedor.58b1e8f3.svg";